import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { FindAllCategoriaSelectAction } from "../../actions/categoriaActions";

export function useCategoriaProductoSelect() {
  
  const query = useQuery({
    queryKey: ["CategoriaProductosList"],
    queryFn: () => FindAllCategoriaSelectAction(),
    staleTime: 60 * 1000,
  });

  const Categorias = computed(() => query.data.value?.data?.data || []);

  return {
    ...query,
    Categorias,
  };
}
